import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import TemplateDropZone from '../../components/TemplateDropZone/TemplateDropZone';
import useFetchData from '../../../../../hooks/useFetchData';
import { useMemo, memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Dialog, DialogContent, DialogTitle } from '@mui/material';
import { loadAssessmentTemplateData } from '../../../../../store/actions/dataEntryAssessmentTemplatesActions';
import { loadSurveyTemplateData } from '../../../../../store/actions/dataEntrySurveyTemplatesActions';
import { alertReset } from '../../../../../store/actions/alert.actions';

const ExportTemplate = memo(({ id, templateType = 'assessment', openModal, setOpenModal, title }) => {
  const { data: dataTypes = [] } = useFetchData('setting/template-types');
  const dispatch = useDispatch();

  const skipAssessment = useSelector((state) => state?.datatable?.assessmentTemplates?.skip || 0);
  const rowsPerPageAssessment = useSelector(
    (state) => state?.datatable?.assessmentTemplates?.rowsPerPage || 100
  );
  const skipSurvey = useSelector((state) => state?.datatable?.surveyTemplates?.skip || 0);
  const rowsPerPageSurvey = useSelector((state) => state?.datatable?.surveyTemplates?.rowsPerPage || 100);

  const handleClose = () => {
    setOpenModal(false);
  };

  const handleRefresh = () => {
    if (templateType === 'assessment') {
      dispatch(
        loadAssessmentTemplateData(
          skipAssessment * rowsPerPageAssessment,
          rowsPerPageAssessment,
          null,
          'assessment'
        )
      );
    } else {
      dispatch(loadSurveyTemplateData(skipSurvey * rowsPerPageSurvey, rowsPerPageSurvey, null, 'survey'));
    }
    dispatch(alertReset());
    handleClose();
  };

  const selectedTemplateType = useMemo(() => {
    return dataTypes?.find((type) => type?.value === templateType);
  }, [dataTypes, templateType]);

  return (
    <Box id={id}>
      <>
        <Dialog open={openModal} fullWidth={true} maxWidth={'md'}>
          <DialogTitle sx={{ m: 0, p: 2 }} id='customized-dialog-title'>
            {title || ''}
            <IconButton
              aria-label='close'
              onClick={handleClose}
              sx={(theme) => ({
                position: 'absolute',
                right: 8,
                top: 8,
                color: theme.palette.grey[500]
              })}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <TemplateDropZone
              handleClose={handleClose}
              handleRefresh={handleRefresh}
              templateType={selectedTemplateType}
              title={title}
              templateTypes={dataTypes}
            />
          </DialogContent>
        </Dialog>
      </>
    </Box>
  );
});

export default ExportTemplate;
